import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const ContactsIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        id="ContactsIcon"
        data-testid="ContactsIcon"
        className="bloxicon"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="28"
      >
        <path
          fill="currentColor"
          d="M22.538 3.33H3.08a1 1 0 0 1 0-1.998h18.823A2.283 2.283 0 0 0 19.83 0H2.282A2.283 2.283 0 0 0 0 2.282v23.154c0 .042.003.084.006.13v.697c0 .817.661 1.478 1.479 1.478h21.037c.817 0 1.478-.661 1.478-1.478V4.805c0-.81-.654-1.468-1.462-1.475ZM12.003 8.523a2.887 2.887 0 1 1 .001 5.774 2.887 2.887 0 0 1 0-5.774Zm5.86 13.198H6.143v-2.227a3.906 3.906 0 0 1 3.907-3.906h3.903a3.906 3.906 0 0 1 3.907 3.906v2.227h.003Z"
        />
      </svg>
    </SvgIcon>
  );
};

export default ContactsIcon;
